import { NewRelic } from '@e3dc-react/shell/Types'
import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { normalizePath } from '../utils/path'

/**
 * This hook normalizes the current path names by replacing dynamic segments (like IDs) with a wildcard.
 * It then sets this normalized path as a custom attribute in New Relic for better observability.
 */
export const useNormalizedPathNames = (): void => {
  const location = useLocation()
  const newRelic = (window as unknown as NewRelic)?.newrelic

  useEffect(() => {
    if (!newRelic) return

    const normalizedPathUrl = normalizePath(location.pathname)

    if (normalizedPathUrl) {
      newRelic.setCustomAttribute('normalizedPathUrl', normalizedPathUrl)
    }
  }, [location.pathname, newRelic])
}
